import { createElement } from "@/utils/create-elem.js";
//import { cells } from "./cells.js";
//mport { tips } from "./tips.js";
import "@/styles/components/timer.scss";

export function Timer(parent) {
  const timer = createElement({
    text: "00:00",
    tag: "div",
    id: "timer",

    classes: ["timer"],
    parent: parent,
  });
}
